<div fxLayout="column" class="campaigns-wrapper">
 
  <div>
    <mat-toolbar fxFlex fxLayout="row">
      <!-- <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="start start" [class.compact-header-text]="media.isActive('lt-sm')">
        <span class="mat-body-1 padding-right-2">
          {{ 'LABEL_RECORD_COUNT' | translate }}
        </span>
        <span class="mat-body-1">
          {{ listLength }}
        </span>
      </div> -->
 
      <!-- <div fxFlex fxLayout fxLayoutAlign="end center">
        <button mat-icon-button [matTooltip]="'LABEL_REFRESH' | translate" [disabled]="loading.init || loading.more" (click)="refresh()">
          <mat-icon svgIcon="refresh"></mat-icon>
        </button>
      </div> -->
    </mat-toolbar>
  </div>
     
  <div fxFlex fxLayoutAlign="center center" class="overflow-auto">
    <div fxFlex="50" class="max-height-100">
      <mat-card class="margin-10 padding-5-per">
        <esc-psr-filter (generateReport)="generateReport($event)"></esc-psr-filter>
      </mat-card>
    </div>
  </div>

  <div *ngIf="loading.init || loading.more || loading.export" fxFlex fxLayout="column" fxLayoutAlign="center center" class="loading-indicator-report">
    <mat-spinner></mat-spinner>
  </div>
  
</div>